import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {Subject} from 'rxjs';

import { IconComponent } from '../../../../../shared/components/icon/icon.component';
import { CardComponent } from '../../../../../shared/components/cards/card/card.component';

@Component({
    selector: 'app-accordion-tab',
    templateUrl: './accordion-tab.component.html',
    styleUrls: ['./accordion-tab.component.scss'],
    standalone: true,
    imports: [CardComponent, IconComponent]
})
export class AccordionTabComponent implements OnInit, OnDestroy {
  @Input() expanded$ = false;
  @Input() canToggleClosed = true;
  @Output() isExpanded: EventEmitter<boolean> = new EventEmitter<boolean>();
  private ngUnsubscribe = new Subject();

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next(null);
    this.ngUnsubscribe.complete();
  }

  public toggleExpanded(): void {
    this.expanded$ = !this.expanded$;
    this.isExpanded.emit(this.expanded$);
  }

  public setExpanded(state: boolean): void {
    console.log('setting expanded:', state)
    this.expanded$ = state;
  }

  get expanded(): boolean {
    return this.expanded$;
  }
}
